import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DotIndicator from '@wix/da-ds/pkg/Indicators/DotIndicator';
import s from './WatchButton.scss';

export interface Props {
  className?: string;
  watchCount: number;
}

const WatchButton: React.FC<Props> = ({ className, watchCount }) => {
  const { t } = useTranslation();

  return (
    <div className={s['button-wrapper']}>
      {watchCount > 0 && <DotIndicator className={s['dot']} />}
      <TextButton
        size="medium"
        variant="main"
        className={className}
        biData={BiData<TopNavClickBiEvent>({
          evid: 700,
          link_url: Url.watchLink(),
          link_name: 'watch',
          indicator: watchCount > 0 ? 1 : 0,
        })}
        href={Url.watchLink()}
      >
        {t('siteHeader.watch')}
      </TextButton>
    </div>
  );
};
WatchButton.displayName = 'WatchButton';

export default WatchButton;
